import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTitle } from "../../../contexts/title";
import PaymentScheduleDetailsGrid from '../../../features/cfi/payment-schedule/components/PaymentScheduleDetailsGrid';

export default function PaymentScheduleDetailsPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Payment Schedule Details')
	}, [pageTitle]);

	const [params] = useSearchParams();
	const date = new Date(params.get("date")!);
	const priceBucketID = Number.parseInt(params.get("priceBucketID")!);
	let priceBucketVersioningID;
	if (!!params.get("priceBucketVersioningID")) {
		priceBucketVersioningID = Number.parseInt(params.get("priceBucketVersioningID")!);
	}

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<PaymentScheduleDetailsGrid
					date={date}
					priceBucketID={priceBucketID}
					priceBucketVersioningID={priceBucketVersioningID} />
			</div>
		</React.Fragment>
	)
} 
